// Simple method to call a callback function on DOM ready event (or immediately if event has already fired).
// https://www.sitepoint.com/jquery-document-ready-plain-javascript/
export default function DOMready(callback) {
    if (
        document.readyState === "complete" ||
        (document.readyState !== "loading" && !document.documentElement.doScroll)
    ) {
        callback();
    } else {
        document.addEventListener("DOMContentLoaded", callback);
    }
}
